import axios from 'axios';

// Imtihon ma'lumotlari uchun umumiy yordamchilar (Students paneli va /exam-result).
// Backend docs/backend-requests.md dagi 1–2-bandlarni qo'shganda o'zgarishlar shu faylda bo'ladi.

// Bekor qilingan (abort) so'rov — xato emas: holatga yozilmaydi va konsolga chiqmaydi.
export const isCanceledRequest = (error) =>
  axios.isCancel(error) ||
  error?.name === 'CanceledError' ||
  error?.name === 'AbortError' ||
  error?.code === 'ERR_CANCELED';

// Boblar `order` bo'yicha o'sish tartibida.
export const sortChapters = (chapters) =>
  [...(Array.isArray(chapters) ? chapters : [])].sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));

// Tanlanadigan bob: so'ralgan id ro'yxatda bo'lsa — o'sha, aks holda birinchisi, bo'sh bo'lsa null.
export const pickChapterId = (chapters, preferredId) => {
  if (!chapters.length) return null;
  const match =
    preferredId !== null &&
    preferredId !== undefined &&
    chapters.find((chapter) => String(chapter.id) === String(preferredId));
  return match ? match.id : chapters[0].id;
};

export const chapterLabel = (chapter) => `${chapter.order}-bob`;

// Joriy bob ulushi (faqat ko'rsatish uchun): chapter_order / number_of_chapters.
export const chapterPercent = (chapterOrder, numberOfChapters) => {
  if (!numberOfChapters || numberOfChapters <= 0) return 0;
  return Math.round((Number(chapterOrder || 0) / numberOfChapters) * 100);
};

// Urinishlar. Hozir API'da urinish raqami va sanasi yo'q — urinishlar massiv tartibida
// "1-urinish", "2-urinish"... deb raqamlanadi (qaysi biri eng yangi ekani noma'lum).
// Backend attempt_number / created_at / max_score qo'shganda (backend-requests.md, 2-band)
// ular avtomatik ishlatiladi.
export const normalizeAttempts = (results) =>
  (Array.isArray(results) ? results : []).map((result, index) => {
    const number = result?.attempt_number ?? index + 1;
    return {
      key: `${number}-${index}`,
      number,
      createdAt: result?.created_at ?? result?.completed_at ?? null,
      maxScore: result?.max_score ?? null,
      result,
    };
  });
